import Fuse from "fuse.js";
import { httpGet } from "@/services/apiService";

export const servicesModule = {
    state: () => ({
        allServices: [],
        fetchingServices: false,
        errorFetchingServices: false,
        selectedServices: [],
        serviceFuse: null,
    }),
    mutations: {
        // Service mutations.
        setAllServices(state, newValue) {
            state.allServices = newValue;
        },
        addService(state, newValue) {
            // Flatten product object
            let newEntry = {
                ...newValue.attributes,
                id: newValue.id,
                cantidad: 1,
            };

            newEntry.precio_unitario_calculado = newEntry.precio_lista;
            newEntry.precio_unitario_final = newEntry.precio_unitario_calculado;
            newEntry.total_local = newEntry.precio_unitario_final * newEntry.cantidad;

            newEntry.selected_destiny = null;

            state.selectedServices.push(newEntry);
        },
        setSelectedServices(state, newValue) {
            state.selectedServices = newValue;
        },
        // Fuse for services
        setServiceFuse(state, newValue) {
            state.serviceFuse = newValue;
        },
        setServiceFetch(state, newValue) {
            state.fetchingServices = newValue;
        },
        setServiceFetchError(state, newValue) {
            state.errorFetchingServices = newValue;
        },
    },
    actions: {
        async getServices({ state, commit }) {
            commit('setServiceFetch', true);
            commit('setServiceFetchError', false);

            try {
                const { data: serviceData } = await httpGet("/servicios");
                sessionStorage.setItem("services", JSON.stringify(serviceData?.data));
                commit('setAllServices', serviceData?.data);
                ("Servicios:", serviceData?.data);
                const fuse = new Fuse([...state.allServices], {
                    includeScore: true,
                    keys: ["attributes.codigo", "attributes.descripcion"],
                });
                commit('setServiceFuse', fuse);

                commit('setServiceFetch', false);
                commit('setServiceFetchError', false);
            } catch (error) {
                commit('setServiceFetch', false);
                commit('setServiceFetchError', true);
            }
        },
        async updateServiceList({ commit }) {
            commit('setServiceFetch', true);
            commit('setServiceFetchError', false);

            try {
                const { data: serviceData } = await httpGet("/servicios");
                sessionStorage.setItem("services", JSON.stringify(serviceData?.data));
                commit('setAllServices', serviceData?.data);
                commit('setServiceFetch', false);
                commit('setServiceFetchError', false);
            } catch (error) {
                commit('setServiceFetch', false);
                commit('setServiceFetchError', true);
            }
        },
        addService({ state, rootState, commit }, item) {
            if (item.attributes.unidad != "FLE") {
                commit("addService", item);
                return;
            }

            // Flatten product object
            let newEntry = {
                ...item.attributes,
                id: item.id,
                cantidad: 1,
            };

            newEntry.precio_unitario_calculado = newEntry.precio_lista;
            newEntry.precio_unitario_final = newEntry.precio_unitario_calculado;
            newEntry.total_local = newEntry.precio_unitario_final * newEntry.cantidad;

            const selectedDestiny = rootState.destinies.selectedDestiny;

            newEntry.transport_options = [];

            for (const t in selectedDestiny.attributes.transportes_isocindu) {
                if (Object.hasOwnProperty.call(selectedDestiny.attributes.transportes_isocindu, t)) {
                    const opt = selectedDestiny.attributes.transportes_isocindu[t];

                    newEntry.transport_options.push({ text: opt.referencia, value: opt.valor })
                }
            }

            newEntry.selected_transport = newEntry.transport_options[0].value ?? 0;
            newEntry.precio_unitario_calculado = newEntry.selected_transport;
            newEntry.precio_unitario_final = newEntry.precio_unitario_calculado;
            newEntry.total_local = newEntry.precio_unitario_final * newEntry.cantidad;
            newEntry.selected_destiny = selectedDestiny.attributes.destino ?? null;

            state.selectedServices.push(newEntry);
        },
        updateService({ state, commit }, item) {
            item.precio_unitario_final = item.precio_unitario_calculado;
            item.total_local = item.precio_unitario_final * item.cantidad;

            commit('setSelectedServices', [...state.selectedServices]);
        },
        deleteService({ state, commit, dispatch }, service) {
            commit("setSelectedServices", state.selectedServices.filter(s => s.id != service.id));
        },
    }
}